module.exports = __webpack_public_path__ + "img/04.6450eac7.jpg";